(() => {
  if (window.treviStickyPurchaseInitialized) return;
  window.treviStickyPurchaseInitialized = true;
  let pending = false;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(cents / 100);
  const topOfHeader = () => Math.max(0,document.querySelector('.header-new--sticky')?.getBoundingClientRect().bottom || 0);
  const update = () => {
    pending = false;
    const root = document.querySelector('.js-product-main');
    const form = root?.querySelector('.js-product-main-form');
    const data = root?.querySelector('.trevi-sticky-product-data');
    if (!form || !data) return;
    let product;
    try {product = JSON.parse(data.textContent)} catch (_) {return}
    const picker = form.querySelector('skio-plan-picker');
    const variantId = Number(form.querySelector('[name="id"]')?.value || picker?.selectedVariant?.id);
    const variant = product.variants.find(v => v.id === variantId) || picker?.selectedVariant || product.variants[0];
    if (!variant) return;
    const planInput = form.querySelector('[name="selling_plan"]');
    const planId = Number(planInput ? planInput.value || 0 : picker?.selectedSellingPlan?.id || 0);
    const plan = (product.selling_plan_groups || []).flatMap(g => g.selling_plans).find(p => p.id === planId);
    const allocation = (variant.selling_plan_allocations || []).find(a => a.selling_plan_id === planId);
    const quantity = Math.max(1,Number(form.querySelector('[name="quantity"]')?.value || 1));
    const count = variant.sku?.match(/^TRV-[ES]-(\d+)-/)?.[1] || product.title.match(/\b(\d+)\s*(?:Stick Packs|Servings?|Count|Pack)/i)?.[1];
    const size = count ? `${count} Pack` : variant.public_title || variant.title?.replace('Default Title','') || '';
    const cadence = plan?.name.match(/every\s+(\d+)\s+(days?|weeks?|months?|years?)/i);
    const frequency = plan ? (cadence ? `delivered every ${cadence[1]} ${cadence[2].toLowerCase()}` : `Subscription: ${plan.name}`) : 'One-time purchase';
    const currency = window.Shopify?.currency?.active || 'USD';
    const price = (allocation?.price ?? variant.price) * quantity;
    const compare = (plan ? variant.price : variant.compare_at_price || 0) * quantity;
    const formula = root.querySelector('.trevi-pdp-formula a[aria-current]')?.textContent.trim() || (variant.sku?.startsWith('TRV-S-') ? 'Sport Rehydration' : variant.sku?.startsWith('TRV-E-') ? 'Daily Hydration' : '');
    const flavor = product.title.split(':').pop().trim();
    const identity = [formula,flavor].filter(Boolean).join(' · ');
    const description = `${quantity > 1 ? `${quantity} × ` : ''}${[size,frequency].filter(Boolean).join(', ')} — `;
    document.querySelectorAll('.trevi-purchase-summary').forEach(el => {
      const signature = `${identity}|${description}|${price}|${compare}|${currency}`;
      if (el.dataset.summary === signature) return;
      el.dataset.summary = signature;
      const productLabel = document.createElement('span');productLabel.className='trevi-purchase-identity';productLabel.textContent=identity;
      el.replaceChildren(productLabel,document.createTextNode(description));
      const strong = document.createElement('strong'); strong.textContent = money(price,currency);el.append(strong);
      if (compare > price) {const del=document.createElement('del');del.textContent=money(compare,currency);el.append(' ',del)}
    });
    let nav = document.querySelector('.ProductNavigationBar');
    if (!nav) {
      nav=document.createElement('section');nav.className='ProductNavigationBar trevi-purchase-fallback';
      nav.innerHTML='<div class="ProductNavigationBar-wrapper"><div class="ProductNavigationBar-product"><h1></h1></div><ul class="ProductNavigationBar-elements"><li class="trevi-sticky-purchase-action"><p class="trevi-purchase-summary trevi-purchase-summary--desktop" aria-live="polite"></p><button class="btn reverse js-product-navigation-atc" type="button">Add to Cart</button></li></ul></div>';
      document.body.append(nav);
      nav.querySelector('button').addEventListener('click',()=>document.querySelector('.js-product-main .js-main-product-submit')?.click());
      schedule();
    }
    const original = form.querySelector('.js-main-product-submit');
    const navButton = nav?.querySelector('.js-product-navigation-atc');
    if (navButton && original) {navButton.disabled = original.disabled; const label=original.disabled ? original.textContent.trim() : 'Add to Cart';if(navButton.textContent!==label)navButton.textContent=label}
    const title = nav?.querySelector('.ProductNavigationBar-product h1');
    if (title && title.textContent !== identity) title.textContent = identity;
    if (nav && window.innerWidth >= 1024 && original) {
      const controls = form.querySelector('.ProductForm-controls');
      nav.classList.toggle('trevi-purchase-sticky',controls && controls.getBoundingClientRect().bottom < topOfHeader());
      const header = document.querySelector('.header-new--sticky');
      const top = Math.max(0,header?.getBoundingClientRect().bottom || 0);
      nav.style.setProperty('--trevi-purchase-top',`${top}px`);
    }
  };
  const schedule = () => {if (!pending) {pending=true;requestAnimationFrame(update)}};
  document.addEventListener('change',schedule);
  document.addEventListener('input',schedule);
  document.addEventListener('skio::update-selling-plan',schedule);
  document.addEventListener('theme:product_Swatches_loaded_request',schedule);
  document.addEventListener('shopify:section:load',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','data-product-id']});
  schedule();
})();
